import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../../../ampli';
import { postPokeToUserSellTractor } from '../../../../api/product/mutations/postPokeToUserSellTractor';

export const usePostPokeToUserSellTractor = () => {
  const location = useLocation();

  return useMutation(postPokeToUserSellTractor, {
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '판매트랙터 찔러보기 실패',
        '에러가 발생한 URL': location.pathname,
      }),
  });
};
